import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from '@apply/adminStore';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { router } from './router';
import { syncAppliedCss } from './appRoutes/components/cssUtils';
import oldAdminCssUrl from './scss/app.scss?url';
import appCssUrl from '@apply-scss/app.scss?url';
import nonAuthCssUrl from '@apply-scss/applications/nonAuthenticated.scss?url';
import brokerCssUrl from '@apply-scss/applications/broker.scss?url';

const queryClient = new QueryClient();

const AUTH_PATHS = new Set(['/login', '/forgotPassword', '/resetPassword']);
const BROKER_PATHS = new Set(['/referrals', '/settings']);

async function bootstrap() {
    window.__removeCss?.();

    // Apply CSS before rendering to prevent flash of unstyled content.
    // useLayoutEffect in layout components handles CSS swaps on client-side navigation.
    const { pathname } = window.location;
    const initialCss = AUTH_PATHS.has(pathname)
        ? [appCssUrl, nonAuthCssUrl]
        : BROKER_PATHS.has(pathname)
          ? [appCssUrl, brokerCssUrl]
          : [oldAdminCssUrl];
    window.__LAYOUT_CSS__ = initialCss;
    await window.__applyCss(initialCss);
    syncAppliedCss(initialCss);

    const root = ReactDOM.createRoot(document.getElementById('root')!);
    root.render(<AppComponent />);
}

const AppComponent = () => (
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <Provider store={store}>
                <RouterProvider router={router} />
            </Provider>
        </QueryClientProvider>
    </React.StrictMode>
);
bootstrap();
